import { ReactElement, useState } from 'react';
import DOMPurify from 'dompurify';
import { NutritionLabelModal } from '../../shared/modal/NutritionLabelModal';
import { Product, Sku } from '../../../models/product.types';
import styles from '../ProductDisplayPage.module.scss';

type Props = {
  sku: Sku,
  product: Product,
}

export function Description({
  sku,
  product,
}: Props): ReactElement {
  const [isNutritionLabelOpen, setIsNutritionLabelOpen] = useState(false);

  // dompurify sanitizer for description input that will be rendered in HTML
  const cleanDescription = DOMPurify.sanitize(sku.description || '', {
    ALLOWED_TAGS: ['p', 'br', 'div', 'span', 'strong', 'b', 'i', 'u',
      'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  });

  return (
    <div className={styles.accordion_container}>
      <div className={styles.description_container}>
        <div
          className={styles.description_content}
          dangerouslySetInnerHTML={{ __html: cleanDescription }}
        />
        {sku?.allergens && (
          <div style={{ marginBottom: '10px' }}>
            <strong>Allergens: </strong>
            {sku.allergens}
          </div>
        )}
        {!!sku?.prep_needs?.length && (
          <div style={{ marginBottom: '10px' }}>
            <strong>Tools: </strong>
            {sku.prep_needs.join(', ')}
          </div>
        )}
      </div>

      <div className={styles.nutrition_row_container}>
        <div
          role="button"
          tabIndex={0}
          onClick={() => setIsNutritionLabelOpen(true)}
          className={styles.nutrition_label_link}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setIsNutritionLabelOpen(true);
            }
          }}
        >
          View Nutrition Label
        </div>

        {sku?.nutrition_label && (
          <NutritionLabelModal
            isOpen={isNutritionLabelOpen}
            title={product.title || ''}
            subtitle={product?.subtitle || ''}
            nutritionLabel={sku?.nutrition_label}
            onClose={() => setIsNutritionLabelOpen(false)}
            hasIngredients={sku?.ingredients?.length > 0}
          />
        )}
      </div>
    </div>
  );
}
